import { CMS_Content_Module_Text_Video } from './types';
import { Heading } from '@cue/atoms';
import { Video, VideoTypes } from '@cue/molecules';
import { StyledComponent } from '@cue/theme';
import { Mdx } from '@cue/utility';
import styled, { CSSObject } from '@emotion/styled';
import { useMediaAnalytics } from '@project/hooks/use-media-analytics';
import React from 'react';

type TextVideoContentModuleProps = CMS_Content_Module_Text_Video['data'];

export const TextVideoContentModule: React.FC<
  TextVideoContentModuleProps & StyledComponent<TextvideoContentModuleCSSOverride>
> = (props) => {
  const {
    text,
    headline,
    video_url,
    tracking_title,
    label,
    link_text,
    link_url,
    orientation,
    flip_direction,
    customFooter,
    player_type = 'Content_Module_Text_Video',
  } = props;

  return (
    <Container
      className={`cue-text-video-content-module cue-text-video-content-module--${orientation} ${
        flip_direction ? 'cue-text-video-content-module--flipped' : ''
      }`}>
      <div className="cue-text-video-content-module__video">
        {video_url && (
          <Video
            url={video_url}
            trackingTitle={tracking_title || video_url}
            muted={false}
            playing={false}
            videoType={VideoTypes.Default}
            trackingType={player_type}
            useMediaAnalytics={useMediaAnalytics}
          />
        )}
      </div>
      <div className="cue-text-video-content-module__content">
        <div className="cue-text-video-content-module__text">
          {headline && (
            <Heading type="h4" className="cue-text-video-content-module-headline">
              {headline}
            </Heading>
          )}
          {text && <Mdx css_class={'cue-text-video-content-module-text'}>{text}</Mdx>}
          {label || link_text || customFooter ? (
            <div className="cue-text-video-content-module-footer">
              {label && (
                <div className="cue-text-video-content-module-label">
                  <Label className="cue-text-video-content-module-label">{label}</Label>
                </div>
              )}
              {link_text ? (
                <div className="cue-text-video-content-module-link">
                  {link_url ? <a href={link_url}>{link_text}</a> : <span>{link_text}</span>}
                </div>
              ) : null}
              {customFooter ? customFooter() : null}
            </div>
          ) : null}
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div``;
const Label = styled.div``;
export type TextvideoContentModuleCSSOverride = {
  '.cue-text-video-content-module'?: CSSObject;
  '.cue-text-video-content-module-video'?: CSSObject;
  '.cue-text-video-content-module-headline'?: CSSObject;
  '.cue-text-video-content-module-text'?: CSSObject;
  '.cue-text-video-content-module-label'?: CSSObject;
};
